module.exports = __webpack_public_path__ + "img/3_69.51092ea1.png";